<template>
  <div class="_rfp_mctb_list_001_ modal-vue">
    <div class="_rfp_mctb_list_002_ modal-vue--content space-content">
      <div class="_rfp_mctb_list_003_ modal-vue--content-panel space-content">
        <h1 class="_rfp_mctb_list_004_ heading">{{ carouselHeaderText }}</h1>
        <div class="_rfp_mctb_list_005_ vue-tabs">
          <div class="_rfp_mctb_list_006_ nav-tabs-navigation">
            <div class="_rfp_mctb_list_007_ nav-tabs-wrapper">
              <ul role="tablist" class="_rfp_mctb_list_008_ nav nav-tabs">
                <template v-for="(x, index) in storeLocatorModeOptions.CountryList">
                  <li
                    v-if="storeLocatorModeOptions.CountryList.length != 0"
                    :id="x.Name"
                    :key="x.Name"
                    name="tab"
                    aria-selected="true"
                    :aria-controls="x.Name"
                    role="tab"
                    class="_rfp_mctb_list_009_ tab active"
                    :class="{ active__tab: index === tabIndex }"
                    @click="tabEnable(x, index)"
                  >
                    <span role="tab" class="_rfp_mctb_list_0010_ active_tab tabs__link">
                      <span class="_rfp_mctb_list_0011_ title title_center">
                        {{ x.DisplayName }}
                      </span>
                    </span>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div class="_rfp_mctb_list_0012_ tab-content">
            <template v-if="storeLocatorModeOptions.CountryList?.length != 0">
              <template v-for="(x, index) in storeLocatorModeOptions.CountryList">
                <section
                  v-if="index === tabIndex && x.Name === tabValue.Name"
                  :id="x.Name"
                  :key="x.Name"
                  :aria-labelledby="x.Name"
                  role="tabpanel"
                  class="_rfp_mctb_list_0018_ tab-container"
                >
                  <ul class="_rfp_mctb_list_0013_">
                    <template v-for="item in storeLocatorModeOptions.Product.Retailers">
                      <li
                        v-if="item.Country === x.Name"
                        :key="item.Name"
                        class="_rfp_mctb_list_0014_"
                      >
                        <span class="_rfp_mctb_list_0015_">
                          <img class="_rfp_mctb_list_0016_" :src="item.Logo" :alt="item.LogoAlt" />
                        </span>
                        <span
                          class="_rfp_mctb_list_0017_ buy-button"
                          @click="
                            pageRedirectUrl(
                              item.RetailerUrl,
                              item.OpenInNewWindow,
                              item.RetailerTags,
                              item.RetailerTagsGS,
                              item.Name,
                            )
                          "
                        >
                          {{ item.Name }}
                        </span>
                      </li>
                    </template>
                  </ul>
                </section>
              </template>
            </template>
            <template v-else>
              <section role="tabpanel" class="_rfp_mctb_list_0018_ tab-container">
                <ul class="_rfp_mctb_list_0013_">
                  <li
                    v-for="item in storeLocatorModeOptions.Product.Retailers"
                    :key="item.Name"
                    class="_rfp_mctb_list_0014_"
                  >
                    <span class="_rfp_mctb_list_0015_">
                      <img class="_rfp_mctb_list_0016_" :src="item.Logo" :alt="item.LogoAlt" />
                    </span>
                    <span
                      class="_rfp_mctb_list_0017_ buy-button"
                      @click="
                        pageRedirectUrl(
                          item.RetailerUrl,
                          item.OpenInNewWindow,
                          item.RetailerTags,
                          item.RetailerTagsGS,
                          item.Name,
                        )
                      "
                    >
                      {{ item.Name }}
                    </span>
                  </li>
                </ul>
              </section>
            </template>
            <template
              v-if="
                tabRetailerList.length === 0 && storeLocatorModeOptions.CountryList?.length != 0
              "
            >
              <section role="tabpanel" class="_rfp_mctb_list_0018_ tab-container">
                <ul class="_rfp_mctb_list_0013_">
                  <li class="retailer__unavailable">
                    <div class="retailer-unavailable_01">
                      {{ retailerUnavailable }}
                    </div>
                  </li>
                </ul>
              </section>
            </template>
            <template
              v-if="
                storeLocatorModeOptions.Product?.Retailers.length === 0 &&
                storeLocatorModeOptions.CountryList?.length === 0
              "
            >
              <section role="tabpanel" class="_rfp_mctb_list_0018_ tab-container">
                <ul class="_rfp_mctb_list_0013_">
                  <li class="retailer__unavailable">
                    <div class="retailer-unavailable_01">
                      {{ retailerUnavailable }}
                    </div>
                  </li>
                </ul>
              </section>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';

export default {
  name: 'rfp-mctb-list-mode',
  props: {
    storeLocatorModeOptions: {
      type: Object,
      required: false,
    },
    carouselHeaderText: {
      type: String,
      required: false,
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
    initialExtraParams: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      eventProjectDataLayer: {},
      tabIndex: null,
      tabValue: null,
      areaValue: true,
      tabRetailerList: [],
      extraParams: this.initialExtraParams,
    };
  },
  created() {
    if (this.storeLocatorModeOptions.CountryList?.length !== 0) {
      this.tabEnable(this.storeLocatorModeOptions.CountryList?.[0], 0);
    }
    eventBus.on('rfp-mctb-datalayer-event', (val) => {
      this.eventProjectDataLayer = val;
    });
    /* istanbul ignore next */
    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
    eventBus.emit('rfp-mctb-extra-param-component1');
  },
  methods: {
    pageRedirectUrl(redirectURL, OpenInNewWindow, standardTagsString, gsTagsString, retailerName) {
      const service = window.dataLayer ? ServiceType.GA : ServiceType.GSQ;

      try {
        const tags = JSON.parse(window.dataLayer ? standardTagsString : gsTagsString);
        tags &&
          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.productname,
              productId: this.productids,
              retailerName: retailerName,
            },
            extraParams: this.extraParams,
            service,
          });
      } catch (e) {
        console.error(`error/rfp-mctb-list-mode#pageRedirectUrl: ${service} tag parsing failed`, e);
      }

      const target = OpenInNewWindow === true ? '_blank' : '_self';
      window.open(redirectURL, target);
    },
    tabEnable(item, index) {
      this.tabRetailerList = [];
      if (this.storeLocatorModeOptions.Product) {
        for (const retailer of this.storeLocatorModeOptions.Product.Retailers) {
          retailer.Country === item.Name && this.tabRetailerList.push(retailer);
        }
      }
      this.tabIndex = index;
      this.tabValue = item;
    },
  },
};
</script>
